import { React, useState, useEffect } from 'react';
const PageNotFound = () => (
  <>
    <div className='page-not-found-bg'>
      <div className='wrapper'>
        <div className='page-not-found-containt'>
          <div className='page-not-text'>
            {/* <h2>404</h2> */}
            <div className='fourZeroText'>
              {/* <h2>4</h2>
                <div className="iconImageZero"> */}
              {/* <img className="rotate" src="https://julesai.com/assets/images/image26.png" />   */}
              {/* </div>
                <h2>4</h2> */}
              <h1>Page Not Found</h1>
            </div>
            {/* <h3 className="mt3 ">Page not found</h3> */}
            <div className='backToHomeBtn mt3'>
              <a href='/' type='submit' className='btn submitBtn '>
                  Back To Home
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  </>
);
export default PageNotFound;
